import { AxiosRequestConfig } from "axios";
import mock from "../MockConfig";
import { categoryData, pageMappingData } from "@crema/services/db/PlanMaster/PlanData";

// Mock API to handle plan
// mock.onGet("/api/ecommerce/plan").reply((request: AxiosRequestConfig) => {
//   const { search, page } = request.params;

//   let plan = [...planData]; 

//   if (search) {
//     plan = plan.filter(
//       (plan) =>
//         plan.planCategory.toLowerCase().includes(search.toLowerCase()) 
//     );
//   }

//   return [
//     200,
//     {
//       planCount: plan.length,
//       plan: plan.splice(page * 10, (page + 1) * 10), 
//     },
//   ];
// });

// Mock API to handle fetching a single plan by sNo
// mock.onGet("/api/ecommerce/plan/get").reply((request: AxiosRequestConfig) => {
//   const { sNo } = request.params;
//   if (sNo >= 1 && sNo <= 10) {
//     const data = planData.filter((item) => +item.sNo === +sNo); 
//     if (data.length > 0) return [200, data[0]]; 
//   }
//   return [200, planData[0]]; 
// });

// Mock API to handle category
mock.onGet("/api/ecommerce/category").reply((request: AxiosRequestConfig) => {
  const { search, page } = request.params;

  let category = [...categoryData]; 

  if (search) {
    category = category.filter(
      (category) =>
        category.categoryName.toLowerCase().includes(search.toLowerCase()) 
    );
  }

  return [
    200,
    {
      categoryCount: category.length,
      category: category.splice(page * 10, (page + 1) * 10), 
    },
  ];
});

// Mock API to handle fetching a single category by sNo
mock.onGet("/api/ecommerce/category/get").reply((request: AxiosRequestConfig) => {
  const { sNo } = request.params;
  if (sNo >= 1 && sNo <= 10) {
    const data = categoryData.filter((item) => +item.sNo === +sNo); 
    if (data.length > 0) return [200, data[0]]; 
  }
  return [200, categoryData[0]]; 
});

// Mock API to handle pageMapping
mock.onGet("/api/ecommerce/pageMapping").reply((request: AxiosRequestConfig) => {
  const { search, page } = request.params;

  let pageMapping = [...pageMappingData]; 

  if (search) {
    pageMapping = pageMapping.filter(
      (pageMapping) =>
        pageMapping.planCode.toLowerCase().includes(search.toLowerCase()) 
    );
  }

  return [
    200,
    {
      pageMappingCount: pageMapping.length,
      pageMapping: pageMapping.splice(page * 10, (page + 1) * 10), 
    },
  ];
});

// Mock API to handle fetching a single pageMapping by sNo
mock.onGet("/api/ecommerce/pageMapping/get").reply((request: AxiosRequestConfig) => {
  const { sNo } = request.params;
  if (sNo >= 1 && sNo <= 10) {
    const data = pageMappingData.filter((item) => +item.sNo === +sNo); 
    if (data.length > 0) return [200, data[0]]; 
  }
  return [200, pageMappingData[0]]; 
});
